"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Translate_1 = __importDefault(require("../Translate"));

var Button_meta_1 = require("./Button.meta");

var Icon_1 = __importDefault(require("../Icon"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_1 = require("mobx");

var isNullOrUndefined = ksys_app_template_1.utils.typeChecks.isNullOrUndefined;
var isNullOrEmpty = ksys_app_template_1.utils.typeChecks.isNullOrEmpty;

var Button =
/** @class */
function (_super) {
  __extends(Button, _super);

  function Button(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Button_meta_1.BUTTON_CATEGORY_KEY;
    _this.componentKey = Button_meta_1.BUTTON_COMPONENT_KEY;

    _this.handleClick = function (event) {
      var _a = _this.props,
          onClick = _a.onClick,
          payload = _a.payload;

      if (onClick) {
        onClick(event, payload);
      }
    };

    return _this;
  }

  Object.defineProperty(Button.prototype, "hasLabel", {
    get: function get() {
      var _a = this.props,
          children = _a.children,
          text = _a.text;
      return !(isNullOrEmpty(text) && isNullOrEmpty(children));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "ariaProps", {
    get: function get() {
      var _a = this.props,
          iconProps = _a.iconProps,
          describedby = _a.describedby,
          expanded = _a.expanded;
      var aria = {
        'aria-describedby': describedby
      };

      if (!this.hasLabel && iconProps && iconProps.accessibilityText) {
        aria['aria-label'] = iconProps.accessibilityText;
      }

      if (!isNullOrUndefined(expanded)) {
        aria['aria-expanded'] = expanded;
      }

      return aria;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "content", {
    get: function get() {
      var _a = this.props,
          children = _a.children,
          text = _a.text,
          iconProps = _a.iconProps,
          _b = _a.iconPosition,
          iconPosition = _b === void 0 ? 'right' : _b;
      var icon = iconProps && react_1.default.createElement(Icon_1.default, __assign({
        "aria-hidden": true
      }, iconProps));
      return react_1.default.createElement(react_1.Fragment, null, !!icon && iconPosition === 'left' && icon, react_1.default.createElement(Translate_1.default, null, text || children), !!icon && iconPosition === 'right' && icon);
    },
    enumerable: true,
    configurable: true
  });

  Button.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        text = _a.text,
        iconProps = _a.iconProps,
        iconPosition = _a.iconPosition,
        describedby = _a.describedby,
        buttonProps = __rest(_a, ["children", "text", "iconProps", "iconPosition", "describedby"]);

    return react_1.default.createElement("button", __assign({}, buttonProps, this.ariaProps, {
      onClick: this.handleClick
    }), this.content);
  };

  Button.defaultProps = {};

  __decorate([mobx_1.computed], Button.prototype, "hasLabel", null);

  __decorate([mobx_1.computed], Button.prototype, "ariaProps", null);

  Button = __decorate([mobx_react_1.observer], Button);
  return Button;
}(shared_1.ComponentBase);

exports.Button = Button;
exports.default = shared_1.InjectedStyledComponent(Button, Button_meta_1.BUTTON_CATEGORY_KEY, Button_meta_1.BUTTON_COMPONENT_KEY);